import HTTPClient from '../..'

export const cloneMonitorByIdAPI = async (id, body) => {
  const data = await HTTPClient.post(`monitor/${id}/clone`, body)
  return data
}
